/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Model from '@tripian/model';
import moment from 'moment';
import classes from './FormTemplateTripNext.scss';
import Button from '../../base/Button/Button';
import StepComponent from './StepComponent/StepComponent';
import StepDestination from './StepDestination/StepDestination';
import StepTravelerInfo from './StepTravelerInfo/StepTravelerInfo';
import Stepper from '../../Stepper/Stepper';
import { SuggestedCityMatch } from '../../DestinationSelect/DestinationSelect';

/**
 * Destinations
 * Stay & Shares
 * Picked Informations
 * Personalize tour trip
 */
interface IFormTemplateTripNext {
  tripProfile: Model.TripProfile;
  tripQuestions: Array<Model.Question>;
  cities: Array<Model.City>;
  isTripEdit?: boolean;
  callbackTripProfile: (tripProfile: Model.TripProfile) => void;
  userCompanionQuestions: Array<Model.Question>;
  userCompanions?: Array<Model.Companion>;
  loadingCompanion: boolean;
  callbackUserCompanionAdd: (userCompoanion: Model.Companion) => void;
  showTripModeQuestion?: boolean;
  initialStep?: number;
  startStep?: number; // Error recovery için - sadece başlangıç step'i, buton mantığını etkilemez
  onStepChange?: (stepId: number) => void;

  stepHeaders: { stepId: number; header: string }[];
  destinationTips: { iconUrl: string; title: string; description: string }[];
  travelerInfoTips: { iconUrl: string; title: string; description: string }[];
  questionDefaultTip: { iconUrl: string; title: string; description: string };

  onSubmitText: string;
  onSubmit: () => void;
  onCancel: () => void;
  t: (value: Model.TranslationKey) => string;
  // AI suggestion feature props
  showAiSuggestions?: boolean;
  citySuggestions?: SuggestedCityMatch[];
  onCitySuggestionsSearch?: (text: string, isQuickSearch?: boolean) => void;
  isCitySearching?: boolean;
  onSelectSuggestedCity?: (cityId: number) => void;
  onClearCitySuggestions?: () => void;
}

const FormTemplateTripNext: React.FC<IFormTemplateTripNext> = ({
  tripProfile,
  tripQuestions,
  cities,
  isTripEdit = false,
  callbackTripProfile,
  userCompanionQuestions,
  userCompanions,
  loadingCompanion,
  callbackUserCompanionAdd,
  showTripModeQuestion = false,
  initialStep,
  startStep,
  onStepChange,
  stepHeaders,
  destinationTips,
  questionDefaultTip,
  travelerInfoTips,
  onSubmitText,
  onSubmit,
  onCancel,
  t,
  // AI suggestion props
  showAiSuggestions,
  citySuggestions,
  onCitySuggestionsSearch,
  isCitySearching,
  onSelectSuggestedCity,
  onClearCitySuggestions,
}) => {
  const [stepId, setStepId] = useState<number>(startStep ?? initialStep ?? -1);
  const [bound, setBound] = useState<google.maps.LatLngBounds | undefined>();
  const topRef = useRef<HTMLDivElement>(null);

  // const tripModeQuestion = tripQuestions.find((question) => question.id === 19);
  const filteredQuestions = useMemo(() => (showTripModeQuestion ? tripQuestions : tripQuestions.filter((x) => x.id !== 19)), [tripQuestions, showTripModeQuestion]);
  const stepQuestions = useMemo(() => filteredQuestions.filter((x) => x.stepId === stepId).sort((a, b) => a.order - b.order), [filteredQuestions, stepId]);

  const stepHeader = useMemo(() => stepHeaders.find((x) => x.stepId === stepId) ?? stepHeaders[0], [stepHeaders, stepId]);
  const isNextButtonDisabledStep1 = useMemo(() => {
    return !tripProfile.cityId || moment.utc(tripProfile.arrivalDatetime).isBefore(moment.utc(), 'day');
  }, [tripProfile.arrivalDatetime, tripProfile.cityId]);

  // const isNextButtonDisabledStep2 = useMemo(() => {
  //  return !tripProfile.accommodation || !tripProfile.accommodation?.coordinate?.lng || !tripProfile.accommodation?.coordinate?.lat;
  // }, [tripProfile.accommodation]);
  const isNextButtonDisabledStep2 = false;

  moment.locale(window.twindow.langCode);

  const callbackTripAnswers = useCallback(
    (answers: Array<number>) => {
      const newTripProfile = { ...tripProfile };
      newTripProfile.answers = answers;
      callbackTripProfile(newTripProfile);
    },
    [callbackTripProfile, tripProfile],
  );

  const setBoundMemo = useCallback((newBound?: google.maps.LatLngBounds | undefined) => setBound(newBound), []);

  // let stepClass;
  // switch (stepId) {
  //   case -1:
  //     stepClass = classes.firstStep;
  //     break;
  //   case 0:
  //     stepClass = classes.secondStep;
  //     break;
  //   case 1:
  //     stepClass = classes.thirdStep;
  //     break;
  //   case 2:
  //     stepClass = classes.fourthStep;
  //     break;
  //   default:
  //     stepClass = classes.firstStep;
  //     break;
  // }

  const destinations: { destinationId: number; destinationName: string; coordinate: Model.Coordinate; parentName: string }[] = useMemo(() => {
    return cities.map((city) => {
      const destination = {
        destinationId: city.id,
        destinationName: city.name,
        coordinate: city.coordinate,
        parentName: city.parentLocations.length === 0 ? city.country.name : `${city.parentLocations.map((parent) => parent.name).join(', ')}, ${city.country.name}`,
      };

      return destination;
    });
  }, [cities]);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [stepId]);

  // Step değiştiğinde callback çağır
  useEffect(() => {
    if (onStepChange) {
      onStepChange(stepId);
    }
  }, [stepId, onStepChange]);

  return (
    <>
      {/* Steps */}
      <div ref={topRef} className={classes.stepsContainer}>
        {/* <ul role="tablist" className={[classes.steps, stepClass].join(' ')}>
          {stepHeaders.map((stepH) => {
            const isSelected = stepH.stepId === stepId;
            const isPassed = stepH.stepId < stepId;
            return (
              <li role="tab" key={stepH.stepId} className={`${isSelected ? classes.selectedStep : ''} ${isPassed ? classes.passedStep : ''}`}>
                <div className={classes.stepHeader}>{stepH.header}</div>
                {stepH.stepId < 2 && <ArrowRight className={classes.stepArrowRight} />}
              </li>
            );
          })}
        </ul> */}
        <div className="hide-m">
          <div className="row m0">
            <div className={classes.header}>{t('trips.createNewTrip.header')}</div>
          </div>
        </div>

        <Stepper stepHeaders={stepHeaders} stepId={stepId} />
      </div>

      <div className={`container ${classes.stepDestination}`}>
        {/* Page 1 */}
        {stepId === -1 && cities.length > 0 && (
          <StepDestination
            tripProfile={tripProfile}
            destinations={destinations}
            setTripProfile={callbackTripProfile}
            isTripEdit={isTripEdit}
            destinationTips={destinationTips}
            showAiSuggestions={showAiSuggestions}
            suggestions={citySuggestions}
            onSuggestionsSearch={onCitySuggestionsSearch}
            isSearching={isCitySearching}
            onSelectSuggestedCity={onSelectSuggestedCity}
            onClearSuggestions={onClearCitySuggestions}
            t={t}
          />
        )}

        {/* Page 2 */}
        {stepId === 0 && (
          <StepTravelerInfo
            tripProfile={tripProfile}
            cities={cities}
            bound={bound}
            setBound={setBoundMemo}
            setTripProfile={callbackTripProfile}
            callbackUserCompanionAdd={callbackUserCompanionAdd}
            loadingCompanion={loadingCompanion}
            userCompanionQuestions={userCompanionQuestions}
            userCompanions={userCompanions}
            travelerInfoTips={travelerInfoTips}
            t={t}
          />
        )}

        {/* Page 3 - 4 */}
        {stepId > 0 && <StepComponent defaultTip={questionDefaultTip} header={stepHeader.header} stepQuestions={stepQuestions} stepId={stepId} tripProfile={tripProfile} callbackTripAnswers={callbackTripAnswers} t={t} />}
        <div className={`row ${classes.formTempButtons}`}>
          <div className="col col12 col7-m m0">
            <div className={`row center ${classes.buttonContainer}`}>
              <div className="col col6">
                {stepId === -1 ? (
                  <Button
                    text={t('trips.createNewTrip.form.cancel')}
                    color="primary"
                    className={classes.cancelButton}
                    onClick={() => {
                      onCancel();
                    }}
                  />
                ) : (
                  <Button
                    text={initialStep !== undefined && stepId <= initialStep ? t('trips.createNewTrip.form.cancel') : t('trips.createNewTrip.form.previous')}
                    color="primary"
                    className={classes.cancelButton}
                    onClick={() => {
                      if (initialStep !== undefined && stepId <= initialStep) {
                        onCancel();
                      } else {
                        setStepId((prevStepId) => prevStepId - 1);
                      }
                    }}
                  />
                )}
              </div>

              <div className="col col6">
                {stepId === -1 ? (
                  <Button
                    text={t('trips.createNewTrip.form.continue')}
                    color="primary"
                    // color={isNextButtonDisabled ? 'disabled' : 'primary'}
                    disabled={isNextButtonDisabledStep1}
                    className={classes.nextButton}
                    onClick={() => {
                      setStepId((prevStepId) => prevStepId + 1);
                    }}
                  />
                ) : stepId === 0 ? (
                  <Button
                    text={t('trips.createNewTrip.form.continue')}
                    color="primary"
                    // color={isNextButtonDisabled ? 'disabled' : 'primary'}
                    disabled={isNextButtonDisabledStep2}
                    className={classes.nextButton}
                    onClick={() => {
                      setStepId((prevStepId) => prevStepId + 1);
                    }}
                  />
                ) : stepId === 2 ? (
                  <Button
                    text={onSubmitText}
                    color="primary"
                    // color={isNextButtonDisabled ? 'disabled' : 'primary'}
                    disabled={isNextButtonDisabledStep1 || isNextButtonDisabledStep2}
                    className={classes.nextButton}
                    onClick={() => {
                      onSubmit();
                    }}
                  />
                ) : (
                  <Button
                    text={t('trips.createNewTrip.form.continue')}
                    color="primary"
                    // color={isNextButtonDisabled ? 'disabled' : 'primary'}
                    disabled={isNextButtonDisabledStep1 || isNextButtonDisabledStep2}
                    className={classes.nextButton}
                    onClick={() => {
                      setStepId((prevStepId) => prevStepId + 1);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormTemplateTripNext;
